import React from 'react';
import styled from 'styled-components/macro';
import { Icon } from '../../icon/Icon';
import { rgba } from 'polished';

export const MenuIcon = ({ ...props }) => {
  return (
    <ClicMenuIcon aria-label="Show menu" {...props}>
      <IconSpan>
        <Icon customLabel="menu" size="large" />
      </IconSpan>
    </ClicMenuIcon>
  );
};

const IconSpan = styled.span`
  display: flex;
`;

const ClicMenuIcon = styled.button`
  display: flex;
  width: 44px;
  height: 44px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 1;

  ${IconSpan} span {
    -webkit-mask-position: center;
    mask-position: center;
    background-color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
    opacity: 0.75;
  }
  &:hover {
    ${IconSpan} span {
      opacity: 1;
    }
  }
  &:active {
    box-shadow: ${(props) =>
      props.theme.name === 'light'
        ? `0px 0px 0px 2px ${rgba(props.theme.color.primaryFull, 0.2)}`
        : `0px 0px 0px 2px ${props.theme.color.primary10}`};
    ${IconSpan} span {
      opacity: 0.75;
    }
  }
  &:focus-visible {
    box-shadow: ${(props) => props.theme.focusRing};
    outline: none;
    ${IconSpan} span {
      opacity: 1;
    }
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;
